<template>
  <abstract-autocomplete
    v-model="localValue"
    :list-api="listApi"
    :multiple="multiple"
    :return-object="returnObject"
    :query-param="queryParam"
    :id-predicate-path="idPredicatePath"
    :show-validation="showValidation"
    :vid="vid"
    :rules="rules"
    :chips="chips"
    :clearable="clearable"
    :deletable-chips="deletableChips"
    :small-chips="smallChips"
    :outlined="outlined"
    :rounded="rounded"
    :dense="dense"
    :single-line="singleLine"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :selected-item-to-text="selectedItemToText"
    :item-value="itemValue"
    :preload-all-options="preloadAllOptions"
    :counter="counter"
    :search-debounce-time="searchDebounceTime"
    @change="$emit('change', $event)"
    @inputObject="$emit('inputObject', $event)"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-item">
        <v-col>Strefa czasowa</v-col>
      </slot>
    </template>
    <template v-slot:item="{ data }">
      <slot name="item" :data="data">
        <v-col>{{ data.item.name }}</v-col>
      </slot>
    </template>
  </abstract-autocomplete>
</template>

<script lang="js">
import LocalValueInput from '@/general/component/form/autocomplete/abstract/LocalValueInput';
import AutocompleteProps from '@/general/component/form/autocomplete/abstract/AutocompleteProps';
import AbstractAutocomplete
  from '@/general/component/form/autocomplete/abstract/AbstractAutocomplete';

export default {
  components: { AbstractAutocomplete },
  mixins: [LocalValueInput, AutocompleteProps],
  props: {
    value: {
      type: [Number, Object, Array],
      default: null
    },
    queryParam: {
      type: String,
      default: ""
    },
    idPredicatePath: {
      type: String,
      default: "id"
    },
    itemValue: {
      type: String,
      default: "id"
    },
    preloadAllOptions: {
      type: Boolean,
      default: true
    },
    vid: {
      type: String,
      default: "timezone"
    },
    label: {
      type: String,
      default: "Strefa czasowa"
    },
    placeholder: {
      type: String,
      default: "Wybierz strefę czasową"
    },
    selectedItemToText: {
      type: Function,
      default: item => item.name
    },
    listApi: {
      type: Function,
      default: (search, query) => {
        return new Promise((resolve, reject) =>
          resolve([
            {id: "Europe/Amsterdam", name: "Europe/Amsterdam"},
            {id: "Europe/Andorra", name: "Europe/Andorra"},
            {id: "Europe/Astrakhan", name: "Europe/Astrakhan"},
            {id: "Europe/Athens", name: "Europe/Athens"},
            {id: "Europe/Belgrade", name: "Europe/Belgrade"},
            {id: "Europe/Berlin", name: "Europe/Berlin"},
            {id: "Europe/Brussels", name: "Europe/Brussels"},
            {id: "Europe/Bucharest", name: "Europe/Bucharest"},
            {id: "Europe/Budapest", name: "Europe/Budapest"},
            {id: "Europe/Chisinau", name: "Europe/Chisinau"},
            {id: "Europe/Copenhagen", name: "Europe/Copenhagen"},
            {id: "Europe/Dublin", name: "Europe/Dublin"},
            {id: "Europe/Gibraltar", name: "Europe/Gibraltar"},
            {id: "Europe/Helsinki", name: "Europe/Helsinki"},
            {id: "Europe/Istanbul", name: "Europe/Istanbul"},
            {id: "Europe/Kaliningrad", name: "Europe/Kaliningrad"},
            {id: "Europe/Kiev", name: "Europe/Kiev"},
            {id: "Europe/Kirov", name: "Europe/Kirov"},
            {id: "Europe/Lisbon", name: "Europe/Lisbon"},
            {id: "Europe/London", name: "Europe/London"},
            {id: "Europe/Luxembourg", name: "Europe/Luxembourg"},
            {id: "Europe/Madrid", name: "Europe/Madrid"},
            {id: "Europe/Malta", name: "Europe/Malta"},
            {id: "Europe/Minsk", name: "Europe/Minsk"},
            {id: "Europe/Monaco", name: "Europe/Monaco"},
            {id: "Europe/Moscow", name: "Europe/Moscow"},
            {id: "Europe/Oslo", name: "Europe/Oslo"},
            {id: "Europe/Paris", name: "Europe/Paris"},
            {id: "Europe/Prague", name: "Europe/Prague"},
            {id: "Europe/Riga", name: "Europe/Riga"},
            {id: "Europe/Rome", name: "Europe/Rome"},
            {id: "Europe/Samara", name: "Europe/Samara"},
            {id: "Europe/Saratov", name: "Europe/Saratov"},
            {id: "Europe/Simferopol", name: "Europe/Simferopol"},
            {id: "Europe/Sofia", name: "Europe/Sofia"},
            {id: "Europe/Stockholm", name: "Europe/Stockholm"},
            {id: "Europe/Tallinn", name: "Europe/Tallinn"},
            {id: "Europe/Tirane", name: "Europe/Tirane"},
            {id: "Europe/Ulyanovsk", name: "Europe/Ulyanovsk"},
            {id: "Europe/Uzhgorod", name: "Europe/Uzhgorod"},
            {id: "Europe/Vienna", name: "Europe/Vienna"},
            {id: "Europe/Vilnius", name: "Europe/Vilnius"},
            {id: "Europe/Volgograd", name: "Europe/Volgograd"},
            {id: "Europe/Warsaw", name: "Europe/Warsaw"},
            {id: "Europe/Zaporozhye", name: "Europe/Zaporozhye"},
            {id: "Europe/Zurich", name: "Europe/Zurich"},
            {id: "Asia/Almaty", name: "Asia/Almaty"}

          ].filter((item) => {
              if(!search || search === ""){ return true }
              return item.name.toLowerCase().includes(search.toLowerCase());
            }
          ))
        );
      }
    }
  }
};
</script>

<style scoped></style>
